<form class="flex flex-col gap-4" (ngSubmit)="onSubmit()" #form="ngForm">
  <!-- Error Alert -->
  @if (userProfileStore.error()) {
  <div class="animate-slideInUp">
    <lib-error-alert [error]="userProfileStore.error()" />
  </div>
  }

  <!-- Success Message -->
  @if (successMessage()) {
  <div class="animate-slideInUp">
    <sb-success-alert [message]="successMessage()" />
  </div>
  }

  <div class="space-y-4">
    <!-- First Name and Last Name -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4 animate-slideInLeft"
      style="animation-delay: 100ms"
    >
      <sb-text-input
        id="first_name"
        name="first_name"
        label="First Name"
        type="text"
        placeholder="First name"
        [required]="true"
        [(ngModel)]="formData().first_name"
        [errorMessage]="formErrors()['first_name'] || ''"
        (inputBlur)="validateField('first_name')"
        (ngModelChange)="updateFormField('first_name', $event)"
      />

      <sb-text-input
        id="last_name"
        name="last_name"
        label="Last Name"
        type="text"
        placeholder="Last name"
        [required]="true"
        [(ngModel)]="formData().last_name"
        [errorMessage]="formErrors()['last_name'] || ''"
        (inputBlur)="validateField('last_name')"
        (ngModelChange)="updateFormField('last_name', $event)"
      />
    </div>

    <!-- Username -->
    <div class="animate-slideInLeft" style="animation-delay: 200ms">
      <sb-text-input
        id="username"
        name="username"
        label="Username"
        type="text"
        placeholder="Username"
        [disabled]="true"
        [readonly]="true"
        [ngModel]="userProfileStore.user()?.username || ''"
        helpText="Username cannot be changed. Contact support if needed."
      />
    </div>

    <!-- Email (Read-only) -->
    <div class="animate-slideInLeft" style="animation-delay: 300ms">
      <sb-text-input
        id="email"
        name="email"
        label="Email Address"
        type="email"
        placeholder="Email address"
        [disabled]="true"
        [readonly]="true"
        [ngModel]="userProfileStore.user()?.email || ''"
        helpText="Email cannot be changed. Contact support if needed."
      />
    </div>

    <!-- Locale and Timezone -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 gap-4 animate-slideInLeft"
      style="animation-delay: 400ms"
    >
      <div>
        <label for="locale" class="block text-sm font-medium text-gray-700 mb-1"
          >Locale</label
        >
        <select
          id="locale"
          name="locale"
          [(ngModel)]="formData().locale"
          (ngModelChange)="updateFormField('locale', $event)"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 transition-colors duration-200 text-gray-700 text-sm"
        >
          @for (locale of localeOptions; track locale.value) {
          <option [value]="locale.value">{{ locale.label }}</option>
          }
        </select>
      </div>

      <div>
        <label
          for="timezone"
          class="block text-sm font-medium text-gray-700 mb-1"
          >Timezone</label
        >
        <select
          id="timezone"
          name="timezone"
          [(ngModel)]="formData().timezone"
          (ngModelChange)="updateFormField('timezone', $event)"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 transition-colors duration-200 text-gray-700 text-sm"
        >
          @for (timezone of timezoneOptions; track timezone.value) {
          <option [value]="timezone.value">{{ timezone.label }}</option>
          }
        </select>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div
    class="flex flex-col sm:flex-row gap-3 animate-slideInUp sm:justify-end"
    style="animation-delay: 500ms"
  >
    <shared-submit-button
      buttonText="Save"
      loadingText="Updating..."
      [isLoading]="userProfileStore.isLoading()"
      [disabled]="!isFormValid()"
      [fullWidth]="true"
      variant="primary"
      size="md"
    />

    <button
      type="button"
      (click)="resetForm()"
      [disabled]="userProfileStore.isLoading()"
      class="flex-1 sm:flex-none px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
    >
      Reset
    </button>
  </div>
</form>
